import { cn } from "@/lib/utils";

export const segmentedTrackClass =
  "rounded-lg border border-surface-200 bg-surface-100/70 p-0.5";

export const segmentedNeutralTrackClass =
  "inline-flex h-9 rounded-lg border border-surface-200 bg-surface-100/70 p-0.5";

export const segmentedNeutralTrackSmClass =
  "inline-flex h-8 shrink-0 rounded-lg border border-surface-200 bg-surface-100/70 p-0.5";

export function segmentedNeutralTriggerClass(
  active: boolean,
  size: "sm" | "md" = "md",
): string {
  return cn(
    "inline-flex h-full items-center gap-1.5 whitespace-nowrap rounded-md font-medium transition-colors",
    size === "sm" ? "px-2.5 text-[13px]" : "px-3 text-sm",
    active
      ? "bg-surface-0 text-surface-900 shadow-xs ring-1 ring-surface-200 dark:bg-surface-200 dark:ring-surface-300/60"
      : "text-surface-500 hover:text-surface-900",
  );
}

export function segmentedTriggerClass(
  active: boolean,
  size: "sm" | "md" = "md",
): string {
  return cn(
    "inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1",
    "disabled:pointer-events-none disabled:opacity-50",
    size === "sm" ? "h-7 px-2.5 text-xs" : "h-8 px-3 text-sm",
    active
      ? "bg-surface-0 text-surface-900 shadow-xs ring-1 ring-surface-200 dark:bg-surface-200 dark:ring-surface-300/60"
      : "text-surface-500 hover:text-surface-900",
  );
}
